import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bundles from '../components/Bundles';
import { incrementBundle, decrementBundle, setBundle, setBundleProductConfig } from 'checkout/views/bundle-picker/actions/bundle-picker';
import { getSubState } from '../../../reducers/subReducerHelpers';
import { getFetchedEventBundles } from '../../../selectors/event';

class BundlesContainer extends Component {
    constructor() {
        super();
        this.state = {index: 0};
    }

    render() {
        return(
            <Bundles
                bundles={this.props.bundles}
                quantityArrays={this.props.quantityArrays}
                initialQuantities={this.props.initialQuantities}
                bundleQuantities={this.props.bundleQuantities}
                onQuantityChange={this.onQuantityChange}
                onIncrement={this.onIncrement}
                onDecrement={this.onDecrement}
                reducerKey={this.props.reducerKey}
            />
        )
    }

    onQuantityChange = (id) => {
        return (e) => {
            this.props.setBundle(id, +e.target.value, this.props.reducerKey);
        };
    };

    onIncrement = (bundle) => {
        this.props.incrementBundle(bundle.id, this.props.reducerKey);
        Object.values(bundle.contents.products).map(product => {
            if (product.single_configuration) {
                this.props.setBundleProductConfig({
                    bundleId: bundle.id,
                    index: this.state.index++,
                    productId: product.product_id,
                    configurationId: product.configurations[0].product_configuration_id,
                }, this.props.reducerKey);
            }
        })
    };

    onDecrement = (id) => {
        this.props.decrementBundle(id, this.props.reducerKey);
    }
}

const mapStateToProps = (state, props) => {
    const bundlePickerState = getSubState(state.bundlePicker, props.reducerKey);

    return {
        bundles: getFetchedEventBundles(state, props.reducerKey),
        quantityArrays: Object.keys(bundlePickerState.availableQuantities).length > 0 ? bundlePickerState.availableQuantities : bundlePickerState.bundleQuantityArrays,
        bundleQuantities: bundlePickerState.bundleQuantities,
        initialQuantities: bundlePickerState.bundleQuantityArrays,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({incrementBundle, decrementBundle, setBundle, setBundleProductConfig}, dispatch);
};

BundlesContainer.propTypes = {
    bundles: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(BundlesContainer)
